export class CaseManagerChange {
    caseId:number;
    caseManagerId:number
}